import { Inject, Injectable, Injector } from '@angular/core';
import { find, isString } from 'lodash';

/*
 * Config for utility services
 */
export enum UTILITY_SERVICE_CONFIG {
  PORTAL = 'XprtDataService',
  API = 'ModifierService',
}

@Injectable()
export class UtilityServiceProvider {
  protected fallbackUtilityClass: any =
    this.getUtilityServiceClass('XprtDataService');

  public constructor(
    public injector: Injector,
    @Inject('UtilityServices') public utilityServices,
  ) {}

  public getUtilityServiceClass(predicate: string): any {
    if (!isString(predicate) || !predicate) {
      return false;
    }
    const findCriteria = { UTILITY_TYPE: predicate };

    return find(this.utilityServices, findCriteria);
  }

  public getUtilityService(predicate: string, notFoundValue?): any {
    const serviceClass =
      this.getUtilityServiceClass(predicate) || this.fallbackUtilityClass;
    const service = this.injector.get(serviceClass, notFoundValue);

    return service;
  }
}
